import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import noop from 'lodash/noop';

import { SuiContainer, SuiInfiniteScroll } from '@splashthat/sui';

import FormTemplateSearchInput from './FormTemplateSearchInput';
import FormTemplateLibraryCollection from './FormTemplateLibraryCollection';
import FormTemplateCustomInfoMessage from './FormTemplateCustomInfoMessage';

import { loadNextCustomTemplatesPage, removeQuestion, searchCustomQuestion } from '../../actions/templateLibrary';
import {
    getCustomTemplates,
    getIsLoadingNextPage,
    getCustomSearchTerm,
    getAreAllPagesLoaded,
} from '../../selectors/templateLibrary';

const baseClassName = 'FormTemplateLibraryCustom';

class FormTemplateLibraryCustom extends Component {
    static propTypes = {
        customSearchTerm: PropTypes.string.isRequired,
        customTemplates: PropTypes.array.isRequired,
        onClickTemplate: PropTypes.func.isRequired,
        removeQuestion: PropTypes.func.isRequired,
        searchCustomQuestion: PropTypes.func.isRequired,
        alreadyAddedUniqueNames: PropTypes.arrayOf(PropTypes.string).isRequired,
        isLoadingNextCustomTemplatesPage: PropTypes.bool.isRequired,
        areAllPagesLoaded: PropTypes.bool.isRequired,
        loadNextCustomTemplatesPage: PropTypes.func.isRequired,
    };

    handleHitBottom = () => {
        if (!this.props.areAllPagesLoaded && !this.props.isLoadingNextCustomTemplatesPage) {
            this.props.loadNextCustomTemplatesPage();
        }
    };

    render() {
        const hasCustomTemplates = !!this.props.customTemplates.length;
        const hasCustomSpinner = hasCustomTemplates && this.props.isLoadingNextCustomTemplatesPage;

        return (
            <SuiContainer className={`${baseClassName}`}>
                <FormTemplateSearchInput
                    value={this.props.customSearchTerm}
                    onSearch={this.props.searchCustomQuestion}
                />
                <SuiInfiniteScroll
                    className={hasCustomSpinner ? `${baseClassName}__custom-spinner` : ''}
                    onHitBottom={hasCustomTemplates ? this.handleHitBottom : noop}
                    showLoader={this.props.isLoadingNextCustomTemplatesPage}
                    bottomScrollBuffer={100}
                >
                    {!hasCustomTemplates && !this.props.isLoadingNextCustomTemplatesPage ? (
                        <FormTemplateCustomInfoMessage customSearchTerm={this.props.customSearchTerm} />
                    ) : (
                        <FormTemplateLibraryCollection
                            templates={this.props.customTemplates}
                            searchTerm={this.props.customSearchTerm}
                            onClickTemplate={this.props.onClickTemplate}
                            onRemoveTemplate={this.props.removeQuestion}
                            alreadyAddedUniqueNames={this.props.alreadyAddedUniqueNames}
                            qaId={baseClassName}
                        />
                    )}
                </SuiInfiniteScroll>
            </SuiContainer>
        );
    }
}

const mapStateToProps = (state) => ({
    customTemplates: getCustomTemplates(state),
    isLoadingNextCustomTemplatesPage: getIsLoadingNextPage(state),
    customSearchTerm: getCustomSearchTerm(state),
    areAllPagesLoaded: getAreAllPagesLoaded(state),
});

const mapDispatchToProps = {
    loadNextCustomTemplatesPage,
    removeQuestion,
    searchCustomQuestion,
};

export default connect(mapStateToProps, mapDispatchToProps)(FormTemplateLibraryCustom);
